import { regionCodesOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";
export const conf = defineEntity({
  ...entityFactory("region-code"),
  endpoint: "region-codes",
  operations: regionCodesOps,
  roleView: [ROLE.REGION_CODE_VIEW, ROLE.REGION_CODE_ADMIN],
  roleAdmin: [ROLE.REGION_CODE_ADMIN],
  singularName: (t) => t("Region code"),
  name: (t) => t("Region codes"),
  syncCustomerFilter: true,
});

export default conf;
